import { render, staticRenderFns } from "./PayoutUsdc.vue?vue&type=template&id=78667da2&"
import script from "./PayoutUsdc.vue?vue&type=script&lang=js&"
export * from "./PayoutUsdc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports